var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 21V30.3333",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1803 8.379L5.26634 39.9583C4.87643 40.6336 4.6701 41.3991 4.66786 42.1788C4.66563 42.9585 4.86758 43.7253 5.25361 44.4027C5.63965 45.0802 6.19632 45.6447 6.86827 46.0403C7.54021 46.4358 8.304 46.6486 9.08367 46.6573H46.9163C47.6957 46.6483 48.4591 46.4356 49.1307 46.0401C49.8023 45.6447 50.3588 45.0804 50.7447 44.4033C51.1307 43.7262 51.3328 42.9599 51.3308 42.1805C51.3289 41.4011 51.123 40.6358 50.7337 39.9607L31.8197 8.37667C31.4217 7.71985 30.8611 7.17674 30.1921 6.7998C29.523 6.42286 28.768 6.22482 28 6.22482C27.232 6.22482 26.4771 6.42286 25.808 6.7998C25.1389 7.17674 24.5783 7.71985 24.1803 8.37667V8.379Z",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 37.3333H28.0233",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9721870d55ea30b843825860bf3faf41.svg";
export { ForwardRef as ReactComponent };